import {Page} from "./page";

export class View {
    public viewName: string;
    public parentPage: Page;

    // Promise which is resolved on dismissal of view
    public dismissal: Promise<any> = new Promise<any>((resolve: (value?: any) => void, reject: (reason?: any) => void) => {
        this.viewPromiseResolve = resolve;
        this.viewPromiseReject = reject;
    });
    public viewPromiseResolve: (results?: any) => void;
    public viewPromiseReject: (reason?: any) => void;
}


// WEBPACK FOOTER //
// ./src/app/orchestration/view.ts